import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export function NotAuthorizedIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <svg
        fill="none"
        height="129"
        viewBox="0 0 130 129"
        width="130"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_5_57381)">
          <g filter="url(#a)">
            <ellipse cx="64.5" cy="122.5" fill="#9DA4AE" rx="35" ry="6" />
          </g>
          <path
            d="M63.833 126.165c32.172 0 58.253-26.085 58.253-58.261 0-32.177-26.08-58.261-58.253-58.261S5.579 35.727 5.579 67.903c0 32.177 26.08 58.262 58.254 58.262Z"
            fill="url(#b)"
          />
          <path
            d="M67.528 115.684a1.7 1.7 0 1 1-3.401 0 1.7 1.7 0 0 1 3.401 0Z"
            stroke="#6C737F"
            strokeWidth="2.483"
          />
          <path
            d="M108.805 99.52c.43-1.779 2.96-1.779 3.39 0a1.74 1.74 0 0 0 1.285 1.285c1.779.43 1.779 2.96 0 3.39a1.74 1.74 0 0 0-1.285 1.285c-.43 1.779-2.96 1.779-3.39 0a1.74 1.74 0 0 0-1.285-1.285c-1.779-.43-1.779-2.96 0-3.39a1.74 1.74 0 0 0 1.285-1.285Z"
            fill="#6C737F"
          />
          <circle cx="113.5" cy="82.5" r="1.759" stroke="#6C737F" strokeWidth="2.483" />
          <g filter="url(#c)">
            <ellipse cx="66" cy="79" fill="#6C737F" fillOpacity=".39" rx="26.5" ry="5.5" />
          </g>
          <path
            d="M129.5 38.913a7.33 7.33 0 0 1-7.342 7.338H97.751a9.915 9.915 0 0 1-1.58-.13 9.222 9.222 0 0 1-4.877-15.687 9.222 9.222 0 0 1 6.062-2.618 12.995 12.995 0 0 1 13.756-7.41 12.99 12.99 0 0 1 10.928 11.168h.111a7.333 7.333 0 0 1 6.789 4.528c.37.89.56 1.846.56 2.81Z"
            fill="url(#d)"
          />
          <path
            clipRule="evenodd"
            d="M72.745 27.675c-9.467 0-17.14 7.675-17.14 17.142 0 1 .085 1.982.25 2.937.17.988-.081 1.82-.561 2.3L38.79 66.558a7.62 7.62 0 0 0-2.23 5.387v7.157c0 1.052.852 1.905 1.904 1.905h9.522a1.905 1.905 0 0 0 1.905-1.905v-3.81H53.7a1.905 1.905 0 0 0 1.904-1.904v-3.81h3.81c.505 0 .989-.2 1.346-.557l6.75-6.751c.48-.48 1.311-.732 2.299-.562.955.165 1.936.251 2.936.251 9.467 0 17.14-7.675 17.14-17.143 0-9.467-7.673-17.142-17.14-17.142Zm0 7.619a1.905 1.905 0 0 0 0 3.81 5.714 5.714 0 0 1 5.714 5.713 1.905 1.905 0 1 0 3.809 0c0-5.26-4.264-9.523-9.523-9.523Z"
            fill="url(#e)"
            fillRule="evenodd"
          />
          <path
            d="M.5 95.275a7.306 7.306 0 0 0 7.31 7.311h24.3a9.846 9.846 0 0 0 1.58-.13 9.188 9.188 0 0 0-1.184-18.246 12.942 12.942 0 0 0-24.582 3.743H7.81A7.308 7.308 0 0 0 .5 95.275Z"
            fill="url(#f)"
          />
          <path
            d="M110.429 56.135c-.315-1.235.825-2.347 2.051-2.002l1.984.557a1.655 1.655 0 0 1 .708 2.778l-1.474 1.439c-.912.89-2.445.46-2.76-.776l-.509-1.996ZM13.429 56.135a1.655 1.655 0 0 1 2.051-2.002l1.984.557a1.655 1.655 0 0 1 .708 2.778l-1.474 1.439c-.912.89-2.445.46-2.76-.776l-.51-1.996Z"
            fill="#6C737F"
          />
          <path
            d="M5.388 24.54a5.533 5.533 0 0 0 5.532 5.532h18.366a6.942 6.942 0 0 0 5.037-11.682 6.942 6.942 0 0 0-4.745-2.197 9.784 9.784 0 0 0-18.571 2.826h-.083a5.532 5.532 0 0 0-5.536 5.52Z"
            fill="url(#g)"
          />
          <path
            d="M44.805 7.52c.43-1.779 2.96-1.779 3.39 0 .153.636.65 1.132 1.285 1.285 1.779.43 1.779 2.96 0 3.39a1.743 1.743 0 0 0-1.285 1.285c-.43 1.779-2.96 1.779-3.39 0a1.743 1.743 0 0 0-1.285-1.285c-1.779-.43-1.779-2.96 0-3.39a1.743 1.743 0 0 0 1.285-1.285Z"
            fill="#6C737F"
          />
        </g>
        <defs>
          <linearGradient
            gradientUnits="userSpaceOnUse"
            id="b"
            x1="63.383"
            x2="64.577"
            y1="-9.328"
            y2="195.275"
          >
            <stop stopColor="#E5E7EB" stopOpacity="0" />
            <stop offset="1" stopColor="#E5E7EB" />
          </linearGradient>
          <linearGradient
            gradientUnits="userSpaceOnUse"
            id="d"
            x1="121.723"
            x2="101.333"
            y1="57.462"
            y2="20.26"
          >
            <stop stopColor="#D2D6DB" />
            <stop offset="1" stopColor="#E5E7EB" />
          </linearGradient>
          <linearGradient
            gradientUnits="userSpaceOnUse"
            id="e"
            x1="40.862"
            x2="137.455"
            y1="41.983"
            y2="78.003"
          >
            <stop stopColor="#9DA4AE" />
            <stop offset=".704" stopColor="#384250" />
          </linearGradient>
          <linearGradient
            gradientUnits="userSpaceOnUse"
            id="f"
            x1="33.613"
            x2="13.311"
            y1="113.754"
            y2="76.676"
          >
            <stop stopColor="#D2D6DB" />
            <stop offset="1" stopColor="#E5E7EB" />
          </linearGradient>
          <linearGradient
            gradientUnits="userSpaceOnUse"
            id="g"
            x1="30.346"
            x2="15.013"
            y1="38.501"
            y2="10.535"
          >
            <stop stopColor="#D2D6DB" />
            <stop offset="1" stopColor="#E5E7EB" />
          </linearGradient>
          <filter
            colorInterpolationFilters="sRGB"
            filterUnits="userSpaceOnUse"
            height="55.772"
            id="a"
            width="113.772"
            x="7.614"
            y="94.614"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feBlend in="SourceGraphic" in2="BackgroundImageFix" mode="normal" result="shape" />
            <feGaussianBlur result="effect1_foregroundBlur_5_57381" stdDeviation="10.943" />
          </filter>
          <filter
            colorInterpolationFilters="sRGB"
            filterUnits="userSpaceOnUse"
            height="52.381"
            id="c"
            width="94.381"
            x="18.809"
            y="52.809"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feBlend in="SourceGraphic" in2="BackgroundImageFix" mode="normal" result="shape" />
            <feGaussianBlur result="effect1_foregroundBlur_5_57381" stdDeviation="10.345" />
          </filter>
        </defs>
      </svg>
    </SvgIcon>
  );
}
